function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWidgetBack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 4,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32979_72131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.414 8.00012L9.889 10.4751L9.182 11.1821L6 8.00012L9.182 4.81812L9.889 5.52512L7.414 8.00012Z",
    fill: "#85858E",
    style: {
      fill: "#85858E",
      fill: "color(display-p3 0.5196 0.5216 0.5549)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32979_72131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(2 2)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidgetBack);
export default __webpack_public_path__ + "static/media/widgetBack.098c15b4fd2d9350c7bf4f355775466a.svg";
export { ForwardRef as ReactComponent };